var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
const EditorContext = React.createContext(null);
const EditorContextProvider = ({ editor, children }) => /* @__PURE__ */ React.createElement(EditorContext.Provider, { value: editor }, children);
const EditorContextConsumer = ({ children }) => /* @__PURE__ */ React.createElement(EditorContext.Consumer, null, (value) => children(value));
function withEditorContext(Component) {
  return (props) => /* @__PURE__ */ React.createElement(EditorContextConsumer, null, (editor) => /* @__PURE__ */ React.createElement(Component, __spreadProps(__spreadValues({}, props), { editor })));
}
export {
  EditorContext,
  EditorContextConsumer,
  EditorContextProvider,
  withEditorContext
};
//# sourceMappingURL=EditorContext.js.map
